import { render, staticRenderFns } from "./Thermometer.vue?vue&type=template&id=5352cc1c&scoped=true&"
import script from "./Thermometer.vue?vue&type=script&lang=js&"
export * from "./Thermometer.vue?vue&type=script&lang=js&"
import style0 from "./Thermometer.vue?vue&type=style&index=0&id=5352cc1c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5352cc1c",
  null
  
)

export default component.exports